import { render, staticRenderFns } from "./SliderMobile.vue?vue&type=template&id=f1272c40"
import script from "./SliderMobile.vue?vue&type=script&lang=js"
export * from "./SliderMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RegisterButton: require('/opt/build/repo/components/register/Button.vue').default})
